module.exports = __webpack_public_path__ + "img/quiz-sounds.4b75e210.png";